<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Endereço</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs2>
        <v-container fluid class="py-2">
          <v-layout row wrap>
            <v-flex xs12 v-if="canEditEndereco">
              <v-btn flat @click.stop="onSubmit" :disabled="isFormInvalid">
                <span class="subtitulo">Salvar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <form v-on:submit.prevent="onSubmit">
      <v-layout row wrap class="pt-5 readonly-form" :class="{ 'readonly-form--blocked': !canEditEndereco }">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid>
            <v-layout row wrap class="mt-3">
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.cep"
                  v-mask="'#####-###'"
                  placeholder="00000-000"
                  v-validate="{ rules: { regex: /^[0-9]{5}-[0-9]{3}$/} }"
                  data-vv-as="CEP"
                  data-vv-delay="1000"
                  name="cep"
                  :error-messages="errors.has('cep') ? errors.first('cep') : []"
                  label="CEP"
                  @focusout="buscarCEP"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="form.fields.tipo"
                  v-bind:items="enderecoTipo"
                  v-validate.initial="{ rules: { required: form.fields.logradouro.length > 0 } }"
                  name="tipo"
                  data-vv-as="tipo"
                  :error-messages="errors.has('tipo') ? errors.first('tipo') : []"
                  label="Tipo"
                >
                </v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.logradouro"
                  v-validate.initial="{ rules: { required: form.fields.tipo.length > 0 } }"
                  name="logradouro"
                  data-vv-as="logradouro"
                  :error-messages="errors.has('logradouro') ? errors.first('logradouro') : []"
                  label="Logradouro"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model.number="form.fields.numero"
                  label="Número"
                  type="number"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.complemento"
                  label="Complemento"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.bairro"
                  label="Bairro"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>              
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.cidade"
                  label="Cidade"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  auto
                  v-model="form.fields.uf"
                  v-bind:items="enderecoUF"
                  label="Estado"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 class="switch-fix">
                <strong>Coordenadas manualmente</strong>
                <v-switch
                  v-model="form.fields.coordenadas_manual" 
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
              <transition name="slide-x-transition">
                <div style="width: 100%;" v-if="form.fields.coordenadas_manual">
                  <v-flex xs12 class="mb-3 mt-2">
                    <p class="body">Preencha as coordenadas ou mova o marcador pelo mapa abaixo. Caso você preencha os campos manualmente, o mapa só será atualizado após salvar as alterações.</p>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.fields.latitude_manual"
                      v-validate="{ rules: { required: form.fields.coordenadas_manual } }"
                      name="latitude_manual"
                      data-vv-as="latitude"
                      :error-messages="errors.has('latitude_manual') ? errors.first('latitude_manual') : []"
                      label="Latitude"
                      type="number"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.fields.longitude_manual"
                      v-validate="{ rules: { required: form.fields.coordenadas_manual } }"
                      name="longitude_manual"
                      data-vv-as="longitude"
                      :error-messages="errors.has('longitude_manual') ? errors.first('longitude_manual') : []"
                      label="Longitude"
                      type="number"
                    >
                    </v-text-field>
                  </v-flex>
                  <gmap-map
                    v-if="coords.lat !== null && coords.lng !== null"
                    :center="coords"
                    :zoom="15"
                    :options="{ clickableIcons: false, disableDoubleClickZoom: true, streetViewControl: false, mapTypeControl: true }"
                    style="width: 100%; height: 400px; margin-bottom: 20px;"
                  >
                    <gmap-marker
                      :position="coords"
                      :clickable="false"
                      :draggable="true"
                      @drag="updateManualCoords"
                    >
                    </gmap-marker>
                  </gmap-map>
                </div>
              </transition>
              <v-flex xs12 class="switch-fix">
                <strong>Loteamento</strong>
                <v-switch
                  v-model="form.fields.loteamento" 
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
              <transition name="slide-x-transition">
                <div style="width: 100%;" v-if="form.fields.loteamento">
                  <v-flex xs12>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.fields.loteamento_nome"
                      v-validate="{ rules: { required: form.fields.loteamento } }"
                      name="loteamento_nome"
                      data-vv-as="nome"
                      :error-messages="errors.has('loteamento_nome') ? errors.first('loteamento_nome') : []"
                      label="Nome"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.fields.loteamento_lote"
                      label="Lote"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.fields.loteamento_quadra"
                      label="Quadra"
                    >
                    </v-text-field>
                  </v-flex>
                </div>
              </transition>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
    <ButtonsObservacoesAnexos></ButtonsObservacoesAnexos>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL, cepURL } from '@/config'
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'
  import ButtonsObservacoesAnexos from './ButtonsObservacoesAnexos'
  
  export default {
    components: {
      HeadersDetalhesResumo,
      ButtonsObservacoesAnexos
    },
    data () {
      return {
        coordsUsuario: {
          lat: this.$store.getters['utils/coords'].latitude,
          lng: this.$store.getters['utils/coords'].longitude
        },
        form: {
          fields: {
            cep: '',
            tipo: '',
            logradouro: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            uf: '',
            loteamento: false,
            loteamento_nome: '',
            loteamento_lote: '',
            loteamento_quadra: '',
            coordenadas_manual: false,
            latitude_manual: '',
            longitude_manual: ''
          }
        }
      }
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      enderecoTipo () {
        return this.$store.getters['constants/enderecoTipo']
      },
      enderecoUF () {
        return this.$store.getters['constants/enderecoUF']
      },
      canViewEndereco () {
        return this.$hasGranularPermission('endereco', 'view')
      },
      canEditEndereco () {
        return this.$hasGranularPermission('endereco', 'edit')
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      },
      coords () {
        if (this.imovel.hasOwnProperty('endereco') && this.imovel.endereco.data.latitude !== null && this.imovel.endereco.data.longitude !== null) {
          return {
            lat: (this.imovel.endereco ? this.imovel.endereco.data.latitude : null),
            lng: (this.imovel.endereco ? this.imovel.endereco.data.longitude : null)
          }
        } else {
          return this.coordsUsuario
        }
      }
    },
    watch: {
      imovel () {
        if (this.imovel.hasOwnProperty('endereco')) {
          this.form.fields = Object.assign({}, this.imovel.endereco.data)

          // if (this.imovel.endereco.data.coordenadas_manual) {
          //   this.form.fields.latitude_manual = this.imovel.endereco.data.latitude
          //   this.form.fields.longitude_manual = this.imovel.endereco.data.longitude
          // } else {
          //   this.form.fields.latitude_manual = ''
          //   this.form.fields.longitude_manual = ''
          // }
          this.$set(this.form.fields, 'latitude_manual', this.imovel.endereco.data.latitude)
          this.$set(this.form.fields, 'longitude_manual', this.imovel.endereco.data.longitude)
        }
      }
    },
    methods: {
      buscarCEP () {
        if (!this.canEditEndereco) return
        if (this.form.fields.cep.length !== 9) {
          return
        }

        this.$store.dispatch('utils/showLoading')

        axios.get(`${cepURL}/${this.form.fields.cep}/json`).then((response) => {
          if (response.data.erro) {
            this.$store.dispatch('utils/showSnackbar', {
              text: 'CEP não encontrado. Preencha o endereço manualmente'
            })
          } else {
            this.form.fields.tipo = _.first(response.data.logradouro.split(' '))
            this.form.fields.logradouro = response.data.logradouro.substr(response.data.logradouro.indexOf(' ') + 1)
            this.form.fields.bairro = response.data.bairro
            this.form.fields.cidade = response.data.localidade
            this.form.fields.uf = response.data.uf
          }
          this.$store.dispatch('utils/hideLoading')
        }, () => {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.'
          })
          this.$store.dispatch('utils/hideLoading')
        })
      },
      updateManualCoords (event) {
        if (!this.canEditEndereco) return
        this.$set(this.form.fields, 'latitude_manual', event.latLng.lat())
        this.$set(this.form.fields, 'longitude_manual', event.latLng.lng())
      },
      onSubmit () {
        if (!this.canEditEndereco) return
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            axios.patch(`${apiURL}/imoveis/${this.$route.params.id}`, { endereco: this.form.fields }).then((response) => {
              this.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } })
              this.$store.dispatch('utils/hideLoading')
            }, (error) => {
              let errorText = ''
              if (error.response.data.message === 'COORDS NOT FOUND') {
                errorText = 'Endereço não localizado. Preencha as coordenadas manualmente.'
              } else {
                errorText = 'Servidor indisponível. Tente novamente mais tarde.'
              }
              this.$store.dispatch('utils/showSnackbar', {
                text: errorText
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DetalhesEndereco.vue?02cb0852